module.exports = __webpack_public_path__ + "media/taipei/taipei park2-fce6d81c.jpg";